export default __webpack_public_path__ + "ac2367644e559de4ff330fbb7c273e70.ttf";